import { BaseColor, borderRadius, themeColor } from '@unbounded/unbounded-components'
import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${themeColor(BaseColor.min)};
  border-radius: ${borderRadius};
`
